// extracted by mini-css-extract-plugin
module.exports = {"subSectionContainer":"SubSection_subSectionContainer__hCs6t","title":"SubSection_title__1W8rw","description":"SubSection_description__1lj0M"};